const dots = document.getElementById('dots');
const projects = document.getElementById('projects');
const slideDelay = 5000;

if (dots && projects) {

    let list = Array.from(dots.getElementsByTagName("li"));
    let projectList = Array.from(projects.getElementsByClassName("margin"));

    list.forEach(function(li) {
        li.addEventListener('click', function() {
            toggle(li);
            clearInterval(interval);
        });
    });

    slide();

    let interval = setInterval(function() {
        slide();
    }, list.length * slideDelay);

    function slide() {
        list.forEach(function(li, index) {
            setTimeout(function() {
                index++;
                toggle(li);
            }, index * slideDelay);
        });
    }

    function toggle(li) {
        reset();
        li.classList.add('active');
        let id = li.getAttribute('data-id');
        document.getElementById('project-' + id).classList.add('active');
        setTimeout(function() {
            document.getElementById('project-' + id).classList.add('visible');
        }, 100);
    }

    function reset() {
        list.forEach(function(li) {
            li.classList.remove('active');
            li.classList.remove('visible');
        });
        projectList.forEach(function(li) {
            li.classList.remove('active');
            li.classList.remove('visible');
        });
    }
}
